module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/readable-stream@2.3.8/~/readable-stream/passthrough.js
// module id = 613
// module chunks = 0